import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  styled,
} from "@mui/material";
import { formattedAmountWithoutAed } from "../../../utils/CommonFunction";
import { getApiData } from "../../../utils/APIHelper";
import CircularStats from "./Statistics/CircularStats";
import LinearStats from "./Statistics/LinearStats";
import { ReactComponent as LargeDhiramIcon } from "../../../assets/svg/MwebBlackDhiramIcon.svg";

const StatsCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "0",
  padding: "16px",
  marginBottom: "16px",
  boxShadow: "none",
  borderBottom: "1px solid #D7D8D9",
}));

export default function MobileStatistics() {
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const getSummaryData = async () => {
    setLoading(true);
    try {
      const response = await getApiData(
        "api/project/analytics-dashboard",
        "GET",
        {},
        {},
        false
      );
      if (response?.success) {
        setSummary(response?.data || {});
      }
    } catch (error) {
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSummaryData();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "0 2vw", marginBottom: "24px" }}>
      {/* Customers Stats */}
      <StatsCard>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
            Customers
          </Typography>
        </Box>
        <Typography
          sx={{ fontSize: "24px", fontWeight: "600", color: "#0D0D0E" }}
        >
          {summary?.total_customers?.toLocaleString() || "---"}
        </Typography>
      </StatsCard>

      <StatsCard>
        <LinearStats summary={summary?.project_type_count} />
      </StatsCard>

      <StatsCard>
        <CircularStats summary={summary} />
      </StatsCard>

      <StatsCard>
        <Typography
          sx={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}
        >
          Overall amount
        </Typography>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#0D0D0E",
            marginBottom: "8px",
          }}
        >
          {summary?.total_cost ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <LargeDhiramIcon />
              {formattedAmountWithoutAed(summary?.total_cost)}
            </Box>
          ) : (
            "---"
          )}
        </Typography>
      </StatsCard>
    </Box>
  );
}
